<template>
    <div class="field">
        <label class="label">{{ translate("live_streams.link_to_stream_in_yt") }}</label>
        <div class="control">
            <input class="input" :value="liveStream.vendorData.videoLiveUrl" type="text" readonly />
        </div>
    </div>
</template>

<script>
    import translatorMixin from "../Common/translatorMixin";

    export default {
        name: "basic-youtube",
        mixins: [translatorMixin],
        props: ["liveStream"],
    };
</script>

<style scoped></style>
